/* =========================================================
   Affiche MUSCULATION « Le Club » — la barre chargée à l'échelle.
   API : SNMuscuClub.render(data, opts) -> string SVG
     data : { lift, name, date, total, bar, title, footer }
       total = charge totale (kg) ; bar = poids de la barre (déf. 20)
   Le CHARGEMENT (disques par côté, couleurs officielles) est CALCULÉ
   automatiquement depuis total − barre, en disques décroissants.
     opts : { palette }
   Auto-suffisant (aucune carte) → re-render serveur direct pour l'impression.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066;

  const PALETTES = {
    craie: { label: 'Craie', bg: '#F7F4ED', ink: '#0B2D5B', muted: '#8B94A3', accent: '#FF6B2C', line: '#E3DDD0', bar: '#3A4553', sleeve: '#6B7480', collar: '#9AA3AD' },
    nuit:  { label: 'Nuit',  bg: '#0B2D5B', ink: '#F7F4ED', muted: '#93A1B8', accent: '#FF6B2C', line: '#1E4272', bar: '#C6CEDA', sleeve: '#8C97A8', collar: '#DDE3EC' },
    fonte: { label: 'Fonte', bg: '#15191F', ink: '#F5F2EA', muted: '#8A93A0', accent: '#FF6B2C', line: '#272D36', bar: '#C3C9D2', sleeve: '#868D98', collar: '#DCE1E8' },
    acier: { label: 'Acier', bg: '#E7E9EC', ink: '#14243B', muted: '#77808F', accent: '#FF6B2C', line: '#D3D7DD', bar: '#3A4553', sleeve: '#6B7480', collar: '#9AA3AD' },
  };

  /* Disques olympiques : couleurs officielles, diamètres à l'échelle. */
  const PLATE = {
    25:   { d: 232, w: 24, fill: '#E23D3D', stroke: '#B92F2F' },
    20:   { d: 232, w: 21, fill: '#2F6BD9', stroke: '#2554AC' },
    15:   { d: 204, w: 18, fill: '#F2B31F', stroke: '#C89114' },
    10:   { d: 164, w: 15, fill: '#3E9B5F', stroke: '#2F7A49' },
    5:    { d: 120, w: 12, fill: '#F5F2EA', stroke: '#B9B2A2' },
    2.5:  { d: 96,  w: 10, fill: '#3A4553', stroke: '#252E39' },
    1.25: { d: 80,  w: 9,  fill: '#8A93A0', stroke: '#5E6672' },
  };
  const STEPS = [25, 20, 15, 10, 5, 2.5, 1.25];

  const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const num = s => { const m = String(s == null ? '' : s).replace(',', '.').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const fmt = n => (Math.round(n * 100) / 100).toFixed(2).replace(/\.?0+$/, '').replace('.', ',');
  const fitSize = (text, maxW, maxSize, cwf, ls, minSize) => {
    const n = String(text).length || 1; minSize = minSize || 12;
    for (let s = maxSize; s > minSize; s -= 1) if (n * (cwf * s + ls) <= maxW) return s;
    return minSize;
  };

  /** Chargement par côté : glouton sur les disques décroissants. */
  function plateStack(total, bar) {
    let perSide = (total - bar) / 2;
    const out = [];
    if (!(perSide > 0)) return out;
    for (const kg of STEPS) {
      while (perSide >= kg - 0.001 && out.length < 8) { out.push(kg); perSide = Math.round((perSide - kg) * 1000) / 1000; }
    }
    return out;
  }

  function barbell(cx, cy, plates, p) {
    const half = 320, shoulder = 192;
    let g = `<g>`
      + `<rect x="${cx - shoulder}" y="${cy - 5}" width="${2 * shoulder}" height="10" rx="5" fill="${p.bar}"/>`
      + `<rect x="${cx - half}" y="${cy - 7.5}" width="${half - shoulder}" height="15" rx="5" fill="${p.sleeve}"/>`
      + `<rect x="${cx + shoulder}" y="${cy - 7.5}" width="${half - shoulder}" height="15" rx="5" fill="${p.sleeve}"/>`
      + `<rect x="${cx - shoulder - 10}" y="${cy - 21}" width="10" height="42" rx="3.5" fill="${p.sleeve}"/>`
      + `<rect x="${cx + shoulder}" y="${cy - 21}" width="10" height="42" rx="3.5" fill="${p.sleeve}"/>`;
    for (const side of [-1, 1]) {
      let cur = shoulder + 12;
      for (const kg of plates) {
        const pl = PLATE[kg]; if (!pl) continue;
        const x = side === 1 ? cx + cur : cx - cur - pl.w;
        g += `<rect x="${x}" y="${cy - pl.d / 2}" width="${pl.w}" height="${pl.d}" rx="6" fill="${pl.fill}" stroke="${pl.stroke}" stroke-width="2"/>`;
        cur += pl.w + 3.5;
      }
      const x = side === 1 ? cx + cur + 2 : cx - cur - 2 - 11;
      g += `<rect x="${x}" y="${cy - 20}" width="11" height="40" rx="4" fill="${p.collar}"/>`;
    }
    return g + `</g>`;
  }

  function miniBarbell(cx, y, color) {
    return `<g fill="${color}">`
      + `<rect x="${cx - 96}" y="${y - 1.6}" width="192" height="3.2" rx="1.6"/>`
      + `<rect x="${cx - 104}" y="${y - 11}" width="8" height="22" rx="2.5"/>`
      + `<rect x="${cx - 114}" y="${y - 8}" width="6.5" height="16" rx="2.5"/>`
      + `<rect x="${cx + 96}" y="${y - 11}" width="8" height="22" rx="2.5"/>`
      + `<rect x="${cx + 107.5}" y="${y - 8}" width="6.5" height="16" rx="2.5"/>`
      + `</g>`;
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.craie;
    const cx = PW / 2;

    const total = num(data.total);
    const bar = num(data.bar) != null ? num(data.bar) : 20;
    const plates = total != null ? plateStack(total, bar) : [];
    const totalTxt = total != null ? fmt(total) : '—';

    // Taille du chiffre héros selon le nombre de caractères (3 chiffres = plein pot).
    const heroSize = totalTxt.length >= 5 ? 210 : totalTxt.length >= 4 ? 250 : 300;

    const loading = plates.length
      ? `BARRE ${fmt(bar)} KG + 2 × ( ${plates.map(fmt).join(' + ')} )`
      : (total != null ? `CHARGE ${totalTxt} KG` : '');

    const title = up(data.title) || (total != null ? `LE CLUB DES ${totalTxt} KG` : 'LE CLUB');
    const titleSize = fitSize(title, 700, 58, 0.54, 2, 30);
    const meta = [up(data.name), up(data.date)].filter(Boolean).join(' · ');
    const footer = up(data.footer) || (data.date ? `MEMBRE DEPUIS LE ${up(data.date)}` : '');

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
<text x="${cx}" y="96" font-size="21" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="5">${esc(up(data.lift) || 'VOTRE MOUVEMENT')}</text>
${meta ? `<text x="${cx}" y="136" font-size="17" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="2.5">${esc(meta)}</text>` : ''}
<text x="${cx}" y="500" text-anchor="middle" font-family="Oswald" font-weight="700" fill="${p.ink}"><tspan font-size="${heroSize}">${esc(totalTxt)}</tspan><tspan font-size="${Math.round(heroSize * 0.28)}" fill="${p.accent}" dx="10">KG</tspan></text>
${barbell(cx, 700, plates, p)}
<text x="${cx}" y="880" font-family="Oswald" font-size="${titleSize}" font-weight="700" fill="${p.ink}" text-anchor="middle" letter-spacing="2">${esc(title)}</text>
${loading ? `<text x="${cx}" y="922" font-size="17" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="1.5">${esc(loading)}</text>` : ''}
${miniBarbell(cx, 988, p.accent)}
${footer ? `<text x="${cx}" y="1038" font-size="16" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="4">${esc(footer)}</text>` : ''}
</svg>`;
  }

  window.SNMuscuClub = { render, PALETTES };
})();
